/* file description */
import React from 'react';
import { Input, Tooltip } from 'antd';
// import { TextAutoFillValue } from '../component/TextAutoFillValue';
import AssetTextAutoFillValueMemo from '../component/AssetTextAutoFillValue';
import AssetTextAutoSerialNumberMemo from '../component/AssetTextAutoFillValue/AssetTextAutoSerialNumber';
import { OpenApiInputMemo } from '../component/OpenApiInput';
import { CheckSameInputMemo } from '../component/CheckSameInput';
import { AutoCompleteInputMemo } from '../component/AutoCompleteInput';
import { VALUE_TYPES, COLUMN_FROM } from './consts';
import { TransformNalmalType2TableColumn } from './type';
import _ from 'lodash';
import { Api as FetchAPI } from '@/utils';
import memo from '../component/memo';
import { TextMaxLength } from '@/const';
import { getPlaceHolder } from '../../common/utils';

const InputMemo = memo(Input);

export const transformString2TableColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  moduleInfo,
}) => {
  targetColumn.valueType = VALUE_TYPES.TEXT;

  // 是否是文本框
  const ismultiLine = field?.options?.multiLine;
  const extension = field?.extension || {};

  if (ismultiLine) {
    targetColumn.valueType = VALUE_TYPES.TEXTAREA;
  }

  // 是否是自动获取
  // if (field?.options?.key && field?.options?.auto) {
  //   targetColumn.renderFormItem = (item, data) => {
  //     // 当为表格搜索表单时
  //     if (item.type === 'table' && data.type === 'table') {
  //       return <Input />;
  //     } else {
  //       return <TextAutoFillValue field={field} SystemAPI={SystemAPI} moduleInfo={moduleInfo} />;
  //     }
  //   };
  //   targetColumn.renderSearchItem = (item, data) => {
  //     // 当为表格搜索表单时
  //     return <Input />;
  //   };
  // }

  // 是否是行编号
  // const isListNumber = !!field?.options?.isListNumber;
  // let rowIndex: string;
  // if (isListNumber) {
  //   targetColumn.copyable = false;
  //   targetColumn.renderText = (dom, entity, index) => {
  //     rowIndex = `${index + 1}`;
  //     return rowIndex;
  //   };
  //   targetColumn.fieldProps = {
  //     bordered: false,
  //     disabled: true,
  //   };
  // }
  targetColumn.renderFormItem = (item, config) => {
    return <InputMemo placeholder={getPlaceHolder(field.label)} />;
  };

  if (field?.bizConfig?.autoCode && field?.bizConfig?.isAutoCode) {
    targetColumn.renderFormItem = (item, config) => {
      if (config.from !== 'search') {
        return (
          <AssetTextAutoFillValueMemo
            params={field?.bizConfig?.autoCode}
            funcName={field?.bizConfig?.autoCodeFun}
            isAutoCodeNoPrefix={field?.bizConfig?.isAutoCodeNoPrefix}
            SystemAPI={FetchAPI}
            disabled
          />
        );
      } else {
        return <InputMemo placeholder={getPlaceHolder(field.label)} />;
      }
    };
  }

  if (field?.bizConfig?.generationRule) {
    targetColumn.renderFormItem = (item, config) => {
      if (config.from !== 'search') {
        return (
          <AssetTextAutoSerialNumberMemo SystemAPI={FetchAPI} generationRule={field?.bizConfig?.generationRule} values={config.storeValue} />
        );
      } else {
        return <InputMemo placeholder={getPlaceHolder(field.label)} />;
      }
    };
  }


  if (field?.bizConfig?.isOpenApi) {
    targetColumn.renderFormItem = (_a, config, form) => {
      return (
        <OpenApiInputMemo
          storeValue={config.storeValue}
          form={form}
          config={config}
          field={field}
          columnFrom={config.from}
          API={{ FetchAPI }}
          rowsData={config.formValue}
          moduleInfo={moduleInfo}
        />
      );
    };
  }

  if (field?.bizConfig?.isUpperCase || field?.bizConfig?.isOpenReg || field?.bizConfig?.isOpenSearch) {
    targetColumn.renderFormItem = (_a, config, form) => {
      return (
        <AutoCompleteInputMemo
          storeValue={config.storeValue}
          form={form}
          config={config}
          field={field}
          columnFrom={config.from}
          API={{ FetchAPI }}
          rowsData={config.formValue}
        />
      );
    };
  }

  // 重复校验
  if (field?.bizConfig?.isCheckSame) {
    targetColumn.renderFormItem = (_a, config, form) => {
      if (config?.from === 'search') {
        return <InputMemo placeholder={getPlaceHolder(field.label)} />;
      }
      return (
        <CheckSameInputMemo
          form={form}
          config={config}
          field={field}
          API={{ FetchAPI }}
        />
      );
    };
  }

  targetColumn.render = (dom, entity) => {
    const { value, setViewValue } = entity;
    setViewValue && setViewValue(_.isString(value) ? value : JSON.stringify(value));
    if (_.isObject(value)) {
      return JSON.stringify(value);
    }
    if (value !== undefined && value !== null) {
      return targetColumn.colProps?.span !== 24 && (value || '').length > TextMaxLength ? <Tooltip title={value}>{`${value.slice(0, TextMaxLength)}...`}</Tooltip> : value;
    }
    return '';
  };

  // 支持文本类型的自定义显示，目前是支持上传组件自定义文件大小显示
  if (extension.render) {
    targetColumn.render = (dom: any, entity) => {
      const { value, setViewValue } = entity;
      setViewValue && setViewValue(_.isString(value) ? value : JSON.stringify(value));
      return extension.render(value);
    };
  }
  // console.log('targetColumn', field, Object.keys(extension))
  // if (extension.render) {
  //   console.log('----------')
  //   targetColumn.render = (dom: any, entity: { [x: string]: any }) => {
  //     const value = (entity[field.name] ?? entity?.value) || '';
  //     return extension.render(value);
  //   };
  // }

  // 获取自定义的组件和表单Item配置
  if (field?.bizConfig?.fieldProps) {
    targetColumn.fieldProps = field?.bizConfig?.fieldProps;
  }
  if (field?.bizConfig?.formItemProps) {
    targetColumn.formItemProps = field?.bizConfig?.formItemProps;
  }
  return targetColumn;
};
